import { FC } from 'react'

import styled from 'styled-components'

import { FullScreenModal } from 'src/Components/FullScreenModal'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

import { AdsGenresModalContent } from '../AdsGenresModalContent'

const Container = styled.div<{ $withMargin?: boolean }>`
  display: flex;
  padding-top: ${(props) => (props.$withMargin ? '24px' : '72px')};
  padding-bottom: 80px;
  padding-left: 16px;
  padding-right: 16px;
  flex-direction: column;
  gap: 24px;
  position: relative;

  & > *:first-child + * {
    margin-top: ${(props) => (props.$withMargin ? '-24px' : '0')};
    margin-bottom: ${(props) => (props.$withMargin ? '-24px' : '0')};
  }

  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    margin: 0 auto;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 64px;
    width: 600px;
  }
`

export const AdsGenresModal: FC = () => {
  const { setSearch } = useCustomSearchParams()

  return (
    <FullScreenModal
      showCloseButton
      fixedCloseButton={false}
      open
      closable
      prefixCls='genres'
      onCancel={() => setSearch({ modal: null })}
    >
      <Container $withMargin>
        <AdsGenresModalContent />
      </Container>
    </FullScreenModal>
  )
}
